import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { compose } from 'recompose'
import {
  activities as activitiesApi,
  ajEvents as ajEventsApi,
  assessors as assessorsApi,
  persons as personsApi,
  residentialProjects as residentialProjectsApi
} from 'redux/modules/api'
import { logError, modal, notification, setPage } from 'redux/modules/app'
import { updateSchema } from 'models/contacts'
import appConfig from 'config'
import { checkAssessorEmailAvailability } from 'redux/modules/api/asyncValidations'
import { inviteAssessorToActivityCategory, inviteNewAssessor } from '../../../../models/assessor/'
import { reset } from 'redux-form'


function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      withRouter,
      connect(
        ({ api, auth }) => ({
          activeOrganization: auth.organization,
          assessors: api.assessors
        }),
        {
          ...assessorsApi,
          notification,
          modal,
          push,
          setPage,
          logError,
          uploadPersonImage: personsApi.uploadPersonImage,
          deletePersonImage: personsApi.deletePersonImage,
          resendActivityAssessmentRequest: activitiesApi.resendActivityAssessmentRequest,
          resendRpAssessmentRequest: residentialProjectsApi.resendRpAssessmentRequest,
          resendAjEventAssessmentRequest: ajEventsApi.resendAjEventAssessmentRequest,
          checkAssessorEmailAvailability,
          reset
        }
      )
    )

    class Assessors extends Component {
      static propTypes = {
        getAssessors: PropTypes.func.isRequired,
        getOrganizationAssessors: PropTypes.func.isRequired,
        getAssessorDetail: PropTypes.func.isRequired,
        getAssessorDetailOverview: PropTypes.func.isRequired,
        getAssessorOverview: PropTypes.func.isRequired,
        updateAssessor: PropTypes.func.isRequired,
        deleteAssessor: PropTypes.func.isRequired,
        deleteAssessorActivity: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        setPage: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        inviteAssessor: PropTypes.func.isRequired,
        uploadPersonImage: PropTypes.func.isRequired,
        deletePersonImage: PropTypes.func.isRequired,
        params: PropTypes.object.isRequired,
        activeOrganization: PropTypes.object.isRequired,
        assessors: PropTypes.object.isRequired,
        decoFilter: PropTypes.string,
        getAvailableAssessorsForActivityCategory: PropTypes.func.isRequired,
        getAssessorsActivityCategoryRegistrations: PropTypes.func.isRequired,
        resendActivityAssessmentRequest: PropTypes.func.isRequired,
        resendRpAssessmentRequest: PropTypes.func.isRequired,
        resendAjEventAssessmentRequest: PropTypes.func.isRequired,
        inviteAssessorToActivityCategory: PropTypes.func.isRequired,
        inviteNewAssessor: PropTypes.func.isRequired,
        resendAssessorRegistration: PropTypes.func.isRequired,
        resendAssessorActivityCategoryRegistration: PropTypes.func.isRequired,
        getActivityCategoryRegistrationFiles: PropTypes.func.isRequired,
        resendBecomeAssessor: PropTypes.func.isRequired,
        checkAssessorEmailAvailability: PropTypes.func.isRequired,
        getAssessorFiles: PropTypes.func.isRequired,
        getAccountRegistrations: PropTypes.func.isRequired,
        getPendingActivityCategoryRegistrations: PropTypes.func.isRequired,
        getAssessedActivityList: PropTypes.func.isRequired,
        getAssessorList: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        getAssessorWWCFile: PropTypes.func.isRequired,
        getAssessor: PropTypes.func.isRequired,
        revokeAccess: PropTypes.func.isRequired,
        remindExpiredWWC:  PropTypes.func.isRequired
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount = () => {
        this.onUpdateProps(this.props)
      }
      componentWillReceiveProps(nextProps) {
        const { assessors } = this.props

        const { filter, limit, offset, sort } = nextProps.assessors

        if (
          assessors.filter !== filter ||
          assessors.limit !== limit ||
          assessors.offset !== offset ||
          assessors.sort !== sort
        ) {
          this.onUpdateProps(nextProps)
        }
          if (
              get(assessors, 'registrations.filter') !== get(nextProps, 'assessors.registrations.filter') ||
              get(assessors, 'registrations.limit') !== get(nextProps, 'assessors.registrations.limit') ||
              get(assessors, 'registrations.offset') !== get(nextProps, 'assessors.registrations.offset') ||
              get(assessors, 'registrations.sort') !== get(nextProps, 'assessors.registrations.sort') ||
              get(assessors, 'registrations.invalidate') !== get(nextProps, 'assessors.registrations.invalidate')
          ) {
            this.onUpdateProps(nextProps)
          }

        if (
            get(assessors, 'activities.filter') !== get(nextProps, 'assessors.activities.filter') ||
            get(assessors, 'activities.limit') !== get(nextProps, 'assessors.activities.limit') ||
            get(assessors, 'activities.offset') !== get(nextProps, 'assessors.activities.offset') ||
            get(assessors, 'activities.sort') !== get(nextProps, 'assessors.activities.sort') ||
            get(assessors, 'activities.invalidate') !== get(nextProps, 'assessors.activities.invalidate')
        ) {
          this.onUpdateProps(nextProps)
        }
      }

      onUpdateProps(nextProps) {
        config.list &&
        this.handleGetOrganizationAssessors(nextProps.assessors, this.handleGetBaseFilter(), {
          orgId: this.handleGetOrganizationId(nextProps.activeOrganization.id)
        })
        config.listAccountRegistrations &&
          this.handleGetAccountRegistrations(nextProps.assessors, this.handleGetBaseFilter(), {})
        config.loadActivityCategoryRegistrations &&
        this.handleGetActivityCategoryRegistrations(get(nextProps, 'assessors.registrations'), this.handleGetBaseFilter())
        config.loadAssessedActivities &&
        this.handleGetAssessedActivityList(get(nextProps, 'assessors.activities'), this.handleGetBaseFilter())
        config.detail &&
          this.handleGetAssessor(
              nextProps.params.assessorId,
              nextProps.params.organizationId ||
              this.handleGetOrganizationId(nextProps.activeOrganization.id)
          )
        config.overview &&
        this.handleGetAssessorDetailOverview(
            nextProps.params.assessorId,
            nextProps.params.organizationId ||
            this.handleGetOrganizationId(nextProps.activeOrganization.id)
        )
        config.completeData && this.handleGetAssessorList(nextProps.params.assessorId)
        config.loadFiles && this.handleGetAssessorFiles(
            nextProps.params.assessorId,
            nextProps.params.organizationId || this.handleGetOrganizationId(nextProps.activeOrganization.id)
        )
      }

      handleGetOrganizationId = defaultOrgId => {
        const { decoFilter, params } = this.props

        switch (config.filter || decoFilter) {
          case 'awardUnitAssessors':
            return params.id || params.organizationId || defaultOrgId

          default:
            return defaultOrgId
        }
      }

      handleGetAssessorFiles = (personId, orgId) => {
        return this.props.getAssessorFiles(personId, orgId)
            .catch(this.handleError)
      }

      handleGetAssessorWWCFile = regId => {
        return this.props.getAssessorWWCFile(regId)
            .catch(this.handleError)
      }

      handleGetAssessorOverview = personId => {
        return this.props.getAssessorOverview(personId)
            .catch(this.handleError)
      }

      handleGetAssessorDetailOverview = (personId, orgId) => {
        return this.props.getAssessorDetailOverview(personId, orgId)
            .catch(this.handleError)
      }

      handleDeleteAssessorActivity = (id, personId) => {
        return this.props.deleteAssessorActivity(id)
            .then(() => {
              this.props.notification('Affiliation has been deleted.', {
                status: 'success',
                intlKey: 'notifications.affiliation_has_been_deleted'
              })
              this.handleGetAssessorOverview(personId)
              this.handleSuccess()
            })
            .catch(this.handleError)
      }

      handleInviteAssessorToActivityCategory = (fields, personId, orgId) => {
        return this.props.inviteAssessorToActivityCategory(personId, inviteAssessorToActivityCategory(fields, orgId))
            .then(() => {
              this.props.notification('Invitation has been sent.', {
                status: 'success',
                intlKey: 'notifications.invitation_has_been_sent'
              })
              this.handleGetAssessorsActivityCategoryRegistrations(get(this.props, 'assessors.registrations'), personId)
              this.handleSuccess()
            })
            .catch(this.handleError)
      }

      handleInviteNewAssessor = (fields, orgId) => {
        return this.props.inviteNewAssessor(inviteNewAssessor(fields, orgId))
            .then(() => {
              this.props.notification('Invitation has been sent.', {
                status: 'success',
                intlKey: 'notifications.invitation_has_been_sent'
              })
              this.props.reset('invite-new-assessor')
              this.handleSuccess()
            })
            .catch(this.handleError)
      }

      handleGetAssessors = (assessors, baseFilter, { orgId } = {}) =>
        this.props.getAssessors(assessors, baseFilter, {
          orgId
        })

      handleGetOrganizationAssessors = (assessors, baseFilter, { orgId } = {}) =>
          this.props.getOrganizationAssessors(assessors, baseFilter, {
            orgId
          })

      handleGetAccountRegistrations = (assessors, filter, options = {}) => {
        this.props.getAccountRegistrations(assessors, filter, options)
      }

      handleGetActivityCategoryRegistrations = (assessorRegs, filter) => {
        return this.props.getAssessorsActivityCategoryRegistrations(assessorRegs, filter)
            .catch(this.handleError)
      }

      handleGetAssessedActivityList = (activities, baseFilter, queryParams = {}, withTh = {}) => {
        let data = {}

        let filter = ''

        switch (baseFilter) {
          case 'pendingBecomeAssessorActivity':
            data = { 'type' : 'activity', 'operation': 'becomeAssessor' }
            filter = 'activityState.value=IN_PROGRESS,isAcceptedByAssessor=0,assessor ne null'
            break
          case 'pendingBecomeAssessorAJ':
            data = { 'type' : 'aj', 'operation': 'becomeAssessor' }
            filter = 'state.value=IN_PROGRESS,ajEvent.isAcceptedByAssessor=0,ajEvent.assessor ne null'
            break
          case 'pendingBecomeAssessorRP':
            data = { 'type' : 'rp', 'operation': 'becomeAssessor' }
            filter = 'state.value=IN_PROGRESS,isAcceptedByAssessor=0,assessor ne null'
            break
          case 'waitingActivityToAuthorizationActivity':
            data = { 'type' : 'activity', 'operation': 'activityAuthorization' }
            filter = 'activityState.value=ASSESSMENT,isAcceptedByAssessor=1'
            break
          case 'waitingActivityToAuthorizationAJ':
            data = { 'type' : 'aj', 'operation': 'activityAuthorization' }
            filter = 'state.value=ASSESSMENT,ajEvent.isAcceptedByAssessor=1'
            break
          case 'waitingActivityToAuthorizationRP':
            data = { 'type' : 'rp', 'operation': 'activityAuthorization' }
            filter = 'state.value=ASSESSMENT,isAcceptedByAssessor=1'
            break
          default:
        }

        return this.props.getAssessedActivityList(activities, filter, queryParams, withTh, data)
            .catch(this.handleError)
      }

      handleGetAssessorDetail = ({ orgId, assessorId } = {}) => {
        this.props
          .getAssessorDetail({
            orgId,
            assessorId
          })
          .then(({ body }) => {
            const assessorGlobalId = get(body, 'id')
              ? `(${body.globalId || `ID: ${body.id}`})`
              : ''

            this.props.setPage(
              `${get(body, 'firstName')} ${get(body, 'lastName') || get(body, 'lastName')} ${assessorGlobalId}`,
              false
            )
          })
      }

      handleGetAssessor = (personId, orgId) => {
        this.props.getAssessor(personId, orgId)
            .catch(this.handleError)
      }

      handleGetAssessorList = personId => {
        this.props.getAssessorList(personId)
            .catch(this.handleError)
      }

      handlePrepareUpdateAssessor = (organizationId, personId, fields) => {
        const { assessors } = this.props

        if (fields.file) {
          return this.props
            .uploadPersonImage(personId, fields.file)
            .then(({ body = {} }) => {
              this.handleUpdateAssessor(fields, {
                photoUrl: body.photoUrl
              })
            })
            .catch(this.handleError)
        }

        if (get(assessors, 'detail.person.photoUrl') && !fields.photoUrl) {
          this.props.deletePersonImage(personId).then(() => {
            this.handleUpdateAssessor(organizationId, fields)
          })
          return
        }

        return this.handleUpdateAssessor(organizationId, fields)
      }

      handleUpdateAssessor = (organizationId, fields, photoUrl) => {
        const { params, activeOrganization } = this.props
        const orgId = params.organizationId || activeOrganization.id

        return this.props
          .updateAssessor(
            organizationId,
            fields.id,
            updateSchema(fields, {
              photoUrl,
              isAssessor: true
            })
          )
          .then(() => {

            this.handleGetAssessor(
                this.props.params.assessorId,
                this.props.params.organizationId ||
                this.handleGetOrganizationId(this.props.activeOrganization.id)
            )

            this.props.notification('Assessor has been updated.', {
              status: 'success',
              intlKey: 'notifications.assessor_has_been_updated'
            })
            this.handleGetAssessorDetail({
              orgId,
              assessorId: this.props.params.assessorId
            })
          })
          .catch(this.handleError)
      }

      handleResendAssessorRegistration = id => {
        return this.props.resendAssessorRegistration(id).then(() => {
          this.handleGetAccountRegistrations(get(this.props, 'assessors'), this.handleGetBaseFilter(), {})
          this.props.modal(null)
        }).catch(this.handleError)
      }

      handleResendActivityCategoryRegistration = id => {
        return this.props.resendAssessorActivityCategoryRegistration(id).then(() => {
          this.handleGetActivityCategoryRegistrations(get(this.props, 'assessors.registrations'), this.handleGetBaseFilter())
          this.props.modal(null)
        }).catch(this.handleError)
      }

      handleGetActivityCategoryRegistrationFiles = id => {
        return this.props.getActivityCategoryRegistrationFiles(id).then().catch(this.handleError)
      }

      handleResendBecomeAssessor = (personId, orgId, activityId) => {
        return this.props.resendBecomeAssessor(personId, orgId, activityId).then(() => {
          this.handleGetAssessedActivityList(this.props.assessors.activities, 'pendingBecomeAssessor', {}, {})
          this.props.modal(null)
        }).catch(this.handleError)
      }

      handleResendActivityAssessment = id => {
        this.props.resendActivityAssessmentRequest(id).then(() => {
          this.handleGetAssessedActivityList(this.props.assessors.activities, 'waitingActivityToAuthorization', {}, {})
          this.props.modal(null)
        }).catch(this.handleError)
      }

      handleResendRPAssessment = id => {
        this.props.resendRpAssessmentRequest(id).then(() => {
          this.handleGetAssessedActivityList(this.props.assessors.activities, 'waitingActivityToAuthorization', {}, {})
          this.props.modal(null)
        }).catch(this.handleError)
      }

      handleResendAJAssessment = id => {
        this.props.resendAjEventAssessmentRequest(id).then(() => {
          this.handleGetAssessedActivityList(this.props.assessors.activities, 'waitingActivityToAuthorization', {}, {})
          this.props.modal(null)
        }).catch(this.handleError)
      }

      handleGetAvailableAssessorsForActivityCategory = (orgId, activityCategoryId) => {
        return this.props.getAvailableAssessorsForActivityCategory(orgId, activityCategoryId)
            .catch(this.handleError)
      }


      handleGetAssessorsActivityCategoryRegistrations = (assessorRegs, personId) => {
        const filter = `assessor.person.id=${personId},or(state.value=PENDING,state.value=APPROVAL)`

        return this.props.getAssessorsActivityCategoryRegistrations(assessorRegs, filter)
            .catch(this.handleError)
      }

      handleRevokeAccess = (personId, orgId) => {
        this.props.revokeAccess(personId, orgId)
            .then(() => {
          this.props.notification('Access has been revoked.', {
            status: 'success',
            intlKey: 'notifications.access_has_been_revoked'
          })
         this.handleSuccess()
         this.handleGetAssessorDetailOverview(personId, orgId)
        }).catch(this.handleError)
      }


      handleDeleteAssessor = (assessorId, fields = {}) =>
        this.props
          .deleteAssessor(assessorId, {
            reason: fields.reason
          })
          .then(() => {
            this.props.notification('Assessor has been removed.', {
              status: 'success',
              intlKey: 'notifications.assessor_has_been_removed'
            })
            this.props.push(`${appConfig.publicPath}/assessors`)
          })
          .catch(this.handleError)

      handleInviteAssessor = (oId, fields) => {
        const orgId = get(fields, 'organizationId') || oId
        const email = get(fields, 'email') || get(fields, 'person.email')

        return this.props
          .inviteAssessor(orgId, { email })
          .then(() => {
            this.props.notification('Invitation has been sent.', {
              status: 'success',
              intlKey: 'notifications.invitation_has_been_sent'
            })
            this.handleSuccess()
          })
          .catch(this.handleError)
      }

      remindExpiredWWC = assessorId => {
        return this.props.remindExpiredWWC(assessorId)
          .then(() => {
            this.props.notification('Reminder has been sent.', {
              status: 'success',
              intlKey: 'notifications.reminder_has_been_sent'
            })
            this.handleSuccess()
          })
          .catch(this.handleError)
      }


      toISODateString = date => {
        return date.toISOString().split('T')[0]
      }

      handleGetBaseFilter = () => {
        const {  decoFilter, params } = this.props

        switch (decoFilter || config.filter) {
          case 'pending':
            return 'state.value=PENDING'
          case 'waiting':
            return 'or(state.value=PENDING,state.value=APPROVAL)'
          case 'pendingAssessorAccounts':
              return 'assessorState.value=REG_PENDING'
          case 'pendingBecomeAssessorActivity':
            return 'pendingBecomeAssessorActivity'
          case 'pendingBecomeAssessorAJ':
            return 'pendingBecomeAssessorAJ'
          case 'pendingBecomeAssessorRP':
            return 'pendingBecomeAssessorRP'
          case 'waitingActivityToAuthorizationActivity':
            return 'waitingActivityToAuthorizationActivity'
          case 'waitingActivityToAuthorizationAJ':
            return 'waitingActivityToAuthorizationAJ'
          case 'waitingActivityToAuthorizationRP':
            return 'waitingActivityToAuthorizationRP'
          case 'onlyForOrganization':
            return 'organization.id=' + params.id || params.organizationId
          case 'expiresCPN':

            const now = new Date()

            const nowPlus60Days = new Date(now)

            nowPlus60Days.setDate(nowPlus60Days.getDate() + 60)

            return `and(${[
              `assessorWWC.childProtectionExpirationDate gt ${this.toISODateString(now)}`,
              `assessorWWC.childProtectionExpirationDate lt ${this.toISODateString(nowPlus60Days)}`
            ].join(', ')})`
          case 'expiredCPN':
                return `and(assessorWWC.childProtectionExpirationDate lt ${this.toISODateString(new Date())})`
          case 'revoked':
            return 'person.personState.value=INACTIVE'
          default:
            return ''
        }
      }

      handleSuccess = () => {
        this.props.modal(null)
      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }
      render() {
        return (
          <ComposedComponent
            {...this.props}
            updateAssessor={this.handlePrepareUpdateAssessor}
            deleteAssessor={this.handleDeleteAssessor}
            inviteAssessor={this.handleInviteAssessor}
            getAssessorWWCFile={this.handleGetAssessorWWCFile}
            getAssessorOverview={this.handleGetAssessorOverview}
            getAssessorDetailOverview={this.handleGetAssessorDetailOverview}
            deleteAssessorActivity={this.handleDeleteAssessorActivity}
            inviteAssessorToActivityCategory={this.handleInviteAssessorToActivityCategory}
            inviteNewAssessor={this.handleInviteNewAssessor}
            onGetAvailableAssessorsForActivityCategory={this.handleGetAvailableAssessorsForActivityCategory}
            onGetAssessorsActivityCategoryRegistrations={this.handleGetAssessorsActivityCategoryRegistrations}
            onGetActivityCategoryRegistrationFiles={this.handleGetActivityCategoryRegistrationFiles}
            onGetAssessor={this.handleGetAssessor}
            onGetOrganizationAssessors={this.handleGetOrganizationAssessors}
            onResendAssessorRegistration={this.handleResendAssessorRegistration}
            onResendActivityCategoryRegistration={this.handleResendActivityCategoryRegistration}
            onResendBecomeAssessor={this.handleResendBecomeAssessor}
            onResendActivityAssessment={this.handleResendActivityAssessment}
            onResendRPAssessment={this.handleResendRPAssessment}
            onResendAJAssessment={this.handleResendAJAssessment}
            onGetAssessedActivityList={this.handleGetAssessedActivityList}
            onRevokeAccess={this.handleRevokeAccess}
            onRemindExpiredWWC={this.remindExpiredWWC}
          />
        )
      }
    }
    return enhance(Assessors)
  }
}

export default decorator
